import React, { useState, useEffect } from 'react';
import './HomePage.scss';
import '../../styles/HomePage.scss';
import { useLocation, Link } from 'react-router-dom'; 
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import logoImage_1 from '../../../src/assets/White PNG 1.png';
import logoImage_2 from '../../../src/assets/Black PNG 1.png';
import clsx from 'clsx';

interface RulesPageProps {
  theme: string;
}

const RulesPage: React.FC<RulesPageProps> = ({ theme }) => {
  const [rulesContent, setRulesContent] = useState<string>('');
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<string | null>(null);
  const location = useLocation();

  useEffect(() => {
    const fetchRules = async () => {
      try {
        const response = await fetch('https://api.neontradepro.com/rule/');
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        const data = await response.json();
        if (data && typeof data.content === 'string') {
          setRulesContent(data.content);
        } else {
          setRulesContent('');
        }
      } catch (e: any) {
        setError(e.message);
      } finally {
        setLoading(false);
      }
    };

    fetchRules();
  }, []);

  useEffect(() => {
    const queryParams = new URLSearchParams(location.search);
    if (queryParams.get('theme') !== theme) {
      queryParams.set('theme', theme);
    }
  }, [theme, location.search]);

  const summaryHeader = (props) => <span className={clsx(
    "font-bold",
    theme === 'dark' && "text-white"
  )}>{props.children}</span>

  return (
    <div className={`rules-page ${theme}`}>
      <header className='header'>
        <nav className='nav-container'>
          <div className='logo'>
            <Link to={`/?theme=${theme}`}>
              <img src={theme === 'dark' ? logoImage_1 : logoImage_2} alt='لوگوی نئون' />
            </Link>
          </div>
        </nav>
      </header>

      <div className="rules-page-header">
        <h2>قوانین وبسایت</h2>
        <p>در اینجا می‌توانید قوانین و مقررات مربوط به استفاده از خدمات ما را مشاهده کنید.</p>
      </div>
      <div className='px-0 lg:px-10'>
        {loading && <p>در حال بارگذاری قوانین...</p>}
        {error && <p className="error-message">خطا در بارگذاری قوانین: {error}</p>}
        {!loading && !error && rulesContent === '' && <p>هیچ قانونی برای نمایش وجود ندارد.</p>}
        {!loading && !error && rulesContent !== '' && (
          rulesContent.split("@@@").map((value, index)=>
            <details key={index} className={clsx(
              "mb-4 rounded-lg text-justify group transition-all duration-200 border",
              "shadow-md hover:shadow-2xl hover:scale-[1.007]",
              theme === 'dark' &&  "bg-[#0f1724] text-[#e6eef8] border-[#223042] hover:bg-[#131d2c] hover:shadow-[#152031]",
              theme === 'light' && "bg-[#fff] text-[#0f1724] border-[#dcdcdc] hover:bg-[#ebebeb] hover:shadow-[#878787]"
            )}>
              <summary className='select-none cursor-pointer p-4 list-none flex justify-between'>
                <ReactMarkdown
                  components={{
                    h1: summaryHeader,
                    h2: summaryHeader,
                    h3: summaryHeader,
                    h4: summaryHeader,
                    h5: summaryHeader,
                    h6: summaryHeader,
                  }}
                  remarkPlugins={[remarkGfm]}
                >
                  {value.trim().split("\n", 1)[0]}
                </ReactMarkdown>
                <svg data-accordion-icon className="w-5 h-5 transition-transform duration-200 -rotate-90 group-open:-rotate-180 shrink-0" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24"><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="m5 15 7-7 7 7"/></svg>
              </summary>
              <div className={clsx(
                "markdown-body p-6 rounded-t-xl rounded-b-lg",
                theme === "light"&& "bg-white",
                theme === "dark" && "bg-[#0f1724]"
              )}>
                <ReactMarkdown
                  components={{
                    blockquote: ({children}) => <blockquote className={clsx(
                      "border-r-4 rounded-md",
                      theme === "light" && "border-blue-400 bg-blue-50",
                      theme === "dark" && "border-blue-400 bg-[#1c2b43]"
                    )}>{children}</blockquote>
                  }}
                  remarkPlugins={[remarkGfm]}
                >
                  {value.trim().split("\n").slice(1).join("\n")}
                </ReactMarkdown>
              </div>
            </details>
          )
        )}
        <div className='h-10'></div>
      </div>
    </div>
  );
};

export default RulesPage;